module.exports = __webpack_public_path__ + "static/img/d7.149f3637.png";